/** The edited item of the Import from Contract upload step: the document and where it goes. */
export default class ContractImportItem {
  constructor(item) {
    this.file = item?.file ?? null;
    this.OpportunityId = item?.OpportunityId ?? null;
    // The checklist's notes as they stand, sent with the document so the import adds only what they lack.
    this.ExistingNotes = item?.ExistingNotes ?? '';
  }
}
